import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  keyLoading,
  resetUserProfile,
  selectLoading,
  selectUserProfile,
} from './store/slice'
import { getUserProfileThunk } from './store/thunk'

const useGetUserProfile = (disableCallApi) => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const loading = useSelector(selectLoading(keyLoading.USER_PROFILE))
  const userProfile = useSelector(selectUserProfile)

  useEffect(() => {
    if (!disableCallApi && locale) {
      dispatch(getUserProfileThunk())
    }
  }, [locale])

  useEffect(() => {
    return () => dispatch(resetUserProfile())
  }, [])

  return {
    loading,
    userProfile,
  }
}

export default useGetUserProfile
